module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ro-sign-up-box"
  }, [_c('div', {
    staticClass: "ro-sign-up-box__background",
    on: {
      "click": _vm.closeOverlayBackground
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ro-sign-up-box__content"
  }, [_c('div', {
    staticClass: "ro-sign-up-close"
  }, [_c('button', {
    staticClass: "ro-sign-up-close-button",
    on: {
      "click": _vm.closeOverlay
    }
  }, [_c('sky-svg', {
    attrs: {
      "name": "cross"
    }
  })], 1)]), _vm._v(" "), (_vm.openId === 1) ? _c('div', {
    staticClass: "ro-sign-up-box__tab"
  }, [_c('div', {
    staticClass: "ro-sign-up-box__overline"
  }, [_vm._v("Tilmelding")]), _vm._v(" "), _c('h2', [_vm._v("Er du ledig?")]), _vm._v(" "), _c('div', {
    staticClass: "ro-sign-up-button-wrap"
  }, [_c('div', {
    staticClass: "ro-sign-up-button",
    on: {
      "click": function($event) {
        _vm.toggleTab(2)
      }
    }
  }, [_vm._v("\n                    Jeg er ledig\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "ro-sign-up-button",
    on: {
      "click": function($event) {
        _vm.toggleTab(3)
      }
    }
  }, [_vm._v("\n                    Jeg er i arbejde\n                ")])])]) : _vm._e(), _vm._v(" "), (_vm.openId === 2) ? _c('div', {
    staticClass: "ro-sign-up-box__tab"
  }, [_c('h2', [_vm._v("Tilmelding for ledige")]), _vm._v(" "), _c('p', [_vm._v("\n                Som ledig kan du tilmelde dig et af vores kurser som 6 ugers\n                jobrettet uddannelse. Kontakt os, så sender vi en\n                tilmeldingsblanket til din e-boks.\n            ")]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.openId === 3) ? _c('div', {
    staticClass: "ro-sign-up-box__tab"
  }, [_c('h2', [_vm._v(_vm._s(_vm.courseInfo.title))]), _vm._v(" "), _c('p', [_vm._v("Holdstart: " + _vm._s(_vm.courseInfo.start))]), _vm._v(" "), _c('p', [_vm._v("Tilmelding fortsætter på Voksenuddannelse.dk.")]), _vm._v(" "), _c('div', {
    staticClass: "ro-sign-up-button-wrap"
  }, [_c('a', {
    staticClass: "ro-sign-up-button",
    attrs: {
      "href": _vm.courseInfo.href,
      "target": "_blank"
    }
  }, [_vm._v("Tilmeld på Voksenuddannelse.dk")])])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ro-sign-up-button-wrap"
  }, [_c('a', {
    staticClass: "ro-sign-up-button",
    attrs: {
      "href": "/kurser/kontakt-og-ansatte/",
      "target": "_blank"
    }
  }, [_vm._v("Kontakt Roskilde Handelsskole")])])
}]}


//////////////////
// WEBPACK FOOTER
// /Users/fyrstenberg/Documents/Limbo/Roskilde-Handelsskole-Website-2023/frontend/~/vue-loader/lib/template-compiler.js?{"id":"data-v-cfb089ce"}!/Users/fyrstenberg/Documents/Limbo/Roskilde-Handelsskole-Website-2023/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./scripts/ro-sign-up/RoSignUpBox.vue
// module id = 386
// module chunks = 1